/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Slider from "react-slick";
import {
    AstropayIcon,
    AvalancheIcon,
    BitcoinIcon,
    BNBIcon,
    EthereumIcon,
    LitecoinIcon,
    MastercardIcon,
    NetellerIcon,
    SkrillIcon,
    TetherIcon,
    VisaIcon,
    XRPIcon,
} from "./Icons";
import Icon from "./Icon";
import { Box } from "@mui/material";

const PaymentsSlider = () => {
    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        speed: 1500,
        slidesToShow: 12,
        slidesToScroll: 12,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1365,
                settings: {
                    slidesToShow: 9,
                    slidesToScroll: 9,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
        ],
    };

    const payments = [
        VisaIcon,
        MastercardIcon,
        SkrillIcon,
        NetellerIcon,
        AstropayIcon,
        BitcoinIcon,
        EthereumIcon,
        TetherIcon,
        LitecoinIcon,
        BNBIcon,
        XRPIcon,
        AvalancheIcon,
    ];
    return (
        <>
            <Box
                sx={{
                    "@media (max-width:991px)": {
                        display: "none",
                    },
                }}
                className="payments-slider"
            >
                <Slider {...settings}>
                    {payments?.map((paymentIcon, idx) => {
                        return (
                            <div className="payment-icons-slider-item" key={`payment-icon${idx}`}>
                                <Icon icon={paymentIcon} />
                            </div>
                        );
                    })}
                </Slider>
            </Box>
        </>
    );
};
export default PaymentsSlider;
